<template lang="pug">
v-skeleton-loader.suus__skeleton-loader__btn(
  v-if="isLoading",
  :loading="true",
  type="button",
  :height="44",
  :width="skeletonWidth"
)
v-btn.suus__btn.pr-8.pl-8(
  v-else,
  large,
  depressed,
  :loading="loading",
  :block="block",
  :color="color",
  :class="classArray",
  v-bind="$attrs",
  v-on="$listeners",
  :disabled="disabled"
)
  span.suus__btn__label(:style="labelStyles")
    slot
    | {{ btnLabel }}
</template>

<script lang="ts">
import THEME from "../../constants/theme"
import Vue from "vue"

const { button } = THEME.typography
export default Vue.extend({
  name: "Button",
  props: {
    btnLabel: { type: String, required: false },
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }, // TODO: Rename to showSkeleton
    color: { type: String, default: "primary" },
  },
  computed: {
    classArray(): string[] {
      return [`suus__btn ${this.btnClass}`, `${!this.block ? "px-8" : ""}`]
    },
    skeletonWidth(): string | number {
      return this.block ? "100%" : 190
    },
    labelStyles(): object {
      return {
        color: "#fff",
        ...button,
      }
    },
    btnClass(): string {
      let btnClass = "suus__btn--primary"
      if (this.color === "warn") {
        btnClass = "suus__btn--warn"
      }
      if (this.color === "highlight") {
        btnClass = "suus__btn--highlight"
      }
      if (this.disabled) {
        btnClass = "suus__btn--disabled"
      }
      if (this.color === "dark-grey") {
        btnClass = "suus__btn--dark-grey"
      }
      if (this.color === "white") {
        btnClass = "suus__btn--white"
      }
      return btnClass
    },
  },
})
</script>

<style lang="sass">
$primary-color: rgba(50, 131, 247, 1)
$highlight-color: #22D563
$dark-grey: #939393
.suus__btn
  &--primary
    background-image: linear-gradient(90deg,#40a2f6 0, $primary-color) !important
  &--highlight
    background-color: $highlight-color !important
  &--warn
    background-color: #B00020 !important
  &--disabled
    background-color: #e0e0e0 !important
    color: #9e9e9e !important
  &--dark-grey
    background-color: $dark-grey !important
  &--white
    background-color: #fff !important
    span
      color: $primary-color !important
.suus__skeleton-loader__btn
  .v-skeleton-loader__button
    width: 100%!important
    height: 44px
</style>
